export const STORIES = [{
    title: '2016 Election Forecast',
    url: 'http://projects.fivethirtyeight.com/2016-election-forecast/',
    img: require('../images/storySparklines/projects.fivethirtyeight.com_general-forecast_plot.png'),
    publisher: 'FiveThirtyEight',
    categories: ['politics'],
    medium: 'interactive'
}, {
    title: 'Brexit Live Blog',
    url: 'http://www.bbc.com/news/live/uk-politics-36570120',
    img: require('../images/storySparklines/bbc_news_live_uk-politics-36570120_plot.png'),
    authors: ['Aiden James'],
    publisher: 'BBC',
    categories: ['politics'],
    medium: 'blog'
}, {
    title: '2016 Presidential Election Headquarters',
    url: 'http://www.foxnews.com/politics/elections/2016/presidential-election-headquarters',
    img: require('../images/storySparklines/foxnews.com_politics_elections_2016_presidential-election-headquarters_plot.png'),
    publisher: 'Fox News',
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'Live election results and coverage',
    url: 'http://cnn.com/2016/11/07/politics/live-election-results-coverage/index.html',
    img: require('../images/storySparklines/cnn.com_2016_11_07_politics_live-election-results-coverage_index.html_plot.png'),
    publisher: 'CNN',
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: '2016 Election Night',
    url: 'http://fivethirtyeight.com/live-blog/2016-election-results-coverage/',
    img: require('../images/storySparklines/fivethirtyeight.com_live-blog_2016-election-results-coverage__plot@2x.png'),
    publisher: 'FiveThirtyEight',
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'Trump’s First 100 Days: Here Is What The President-Elect Wants To Do',
    url: 'http://www.npr.org/2016/11/09/501451368/here-is-what-donald-trump-wants-to-do-in-his-first-100-days',
    img: require('../images/storySparklines/npr.org_2016_11_09_501451368_here-is-what-donald-trump-wants-to-do-in-his-first-100-days_plot.png'),
    publisher: 'NPR',
    authors: ['Amita Kelly', 'Barbara Sprunt'],
    categories: ['politics'],
}, {
    title: 'US Election Live Blog',
    url: 'http://www.bbc.com/news/live/election-us-2016-37899679',
    img: require('../images/storySparklines/bbc_news_live_election-us-2016-37899679_plot.png'),
    publisher: 'BBC',
    authors: ['Max Matza', 'Courtney Subramanian', 'Joel Gunter', 'Hugo Bachega'],
    categories: ['politics'],
    medium: 'blog',
}, {
    title: 'EU Referendum Results',
    url: 'http://www.bbc.com/news/politics/eu_referendum/results',
    img: require('../images/storySparklines/bbc_news_politics_eu_referendum_results_plot.png'),
    publisher: 'BBC',
    categories: ['politics'],
    medium: 'blog',
}, {
    title: 'Presidential Election Results 2016',
    url: 'http://cnn.com/election/results/president',
    img: require('../images/storySparklines/cnn.com_election_results_president_plot.png'),
    publisher: 'CNN',
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'Orlando shooting: 49 killed, shooter pledged ISIS allegiance',
    url: 'http://cnn.com/2016/06/12/us/orlando-nightclub-shooting/index.html',
    img: require('../images/storySparklines/cnn.com_2016_06_12_us_orlando-nightclub-shooting_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Ralph Ellis', 'Ashley Fantz', 'Faith Karimi', 'Eliott C. McLaughlin'],
    categories: ['breaking', 'justice'],
}, {
    title: '2016 Presidential Election Results',
    url: 'http://www.politico.com/2016-election/results/map/president',
    img: require('../images/storySparklines/politico.com_2016-election_results_map_president_plot.png'),
    publisher: 'Politico',
    categories: ['politics'],
    medium: 'interactive'
}, {
    title: '2016 Election Forecast: Who Will Be President?',
    url: 'http://nytimes.com/interactive/2016/upshot/presidential-polls-forecast.html',
    img: require('../images/storySparklines/nytimes.com_interactive_2016_upshot_presidential-polls-forecast.html_plot.png'),
    publisher: 'The New York Times',
    authors: ['Josh Katz'],
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'US Election 2016 Results',
    url: 'http://bbc.co.uk/news/election/us2016/results',
    img: require('../images/storySparklines/bbc_news_election_us2016_results_plot.png'),
    publisher: 'BBC',
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'Trump recorded having extremely lewd conversation about women in 2005',
    url: 'https://www.washingtonpost.com/politics/trump-recorded-having-extremely-lewd-conversation-about-women-in-2005/2016/10/07/3b9ce776-8cb4-11e6-bf8a-3d26847eeed4_story.html',
    img: require('../images/storySparklines/washingtonpost.com_politics_trump-recorded-having-extremely-lewd-conversation-about-women-in-2005_2016_10_07_3b9ce776-8cb4-11e6-bf8a-3d26847eeed4_story.html_plot.png'),
    publisher: 'Washington Post',
    authors: ['David A. Fahrenthold'],
    categories: ['breaking', 'politics'],
}, {
    title: 'How Tiger Woods’ life unraveled in the years after father Earl Woods’ death',
    url: 'http://www.espn.com/espn/feature/story/_/id/15278522/how-tiger-woods-life-unraveled-years-father-earl-woods-death',
    img: require('../images/storySparklines/espn_feature_story___id_15278522_how-tiger-woods-life-unraveled-years-father-earl-woods-death_plot.png'),
    publisher: 'ESPN',
    authors: ['Wright Thompson'],
    categories: ['sports'],
    medium: 'longform',
}, {
    title: 'Fact Check And Analysis Of The First Presidential Debate With Donald Trump And Hillary Clinton',
    url: 'http://npr.org/2016/09/26/495115346/fact-check-first-presidential-debate',
    img: require('../images/storySparklines/npr.org_2016_09_26_495115346_fact-check-first-presidential-debate_plot.png'),
    publisher: 'NPR',
    authors: ['NPR Staff'],
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: '‘We’re the Only Plane in the Sky’',
    url: 'http://www.politico.com/magazine/story/2016/09/were-the-only-plane-in-the-sky-214230',
    img: require('../images/storySparklines/politico_magazine_story_2016_09_were-the-only-plane-in-the-sky-214230_plot.png'),
    publisher: 'Politico',
    authors: ['Garrett M. Graff'],
    categories: ['politics'],
    medium: 'longform',
}, {
    title: 'Disney gator attack: 2-year-old Nebraska boy found dead',
    url: 'http://cnn.com/2016/06/15/us/alligator-attacks-child-disney-florida/index.html',
    img: require('../images/storySparklines/cnn.com_2016_06_15_us_alligator-attacks-child-disney-florida_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Eliott C. McLaughlin', 'Joshua Berlinger', 'Ashley Fantz', 'Steve Almasy'],
    categories: ['breaking'],
}, {
    title: 'The one scenario that could still get Hillary into the White House',
    url: 'http://nypost.com/2016/11/09/the-one-scenario-that-could-still-get-hillary-into-the-white-house/',
    img: require('../images/storySparklines/nypost.com_2016_11_09_the-one-scenario-that-could-still-get-hillary-into-the-white-house__plot.png'),
    publisher: 'New York Post',
    authors: ['Laura Italiano'],
    categories: ['politics'],
}, {
    title: '2016 Senate Forecast',
    url: 'https://projects.fivethirtyeight.com/2016-election-forecast/senate/',
    img: require('../images/storySparklines/projects.fivethirtyeight.com_senate-2016_plot.png'),
    publisher: 'FiveThirtyEight',
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'El Chapo Speaks',
    url: 'http://www.rollingstone.com/culture/features/el-chapo-speaks-20160109',
    img: require('../images/storySparklines/rollingstone_culture_features_el-chapo-speaks-20160109_plot.png'),
    publisher: 'Rolling Stone',
    authors: ['Sean Penn'],
    categories: ['culture'],
    medium: 'longform',
}, {
    title: 'Brussels attacks: Latest updates',
    url: 'http://www.bbc.co.uk/news/live/world-europe-35869266',
    img: require('../images/storySparklines/bbc_news_live_world-europe-35869266_plot.png'),
    publisher: 'BBC',
    authors: ['Alastair Lawson'],
    categories: ['breaking'],
    medium: 'blog',
}, {
    title: 'As it happened - pivotal Obama and Trump speeches',
    url: 'http://www.bbc.com/news/live/election-us-2016-35404043',
    img: require('../images/storySparklines/bbc_news_live_election-us-2016-35404043_plot.png'),
    publisher: 'BBC',
    authors: ['Courtney Subramanian', 'Max Matza'],
    categories: ['politics'],
    medium: 'blog',
}, {
    title: '2016 Primary Forecasts',
    url: 'http://projects.fivethirtyeight.com/election-2016/primary-forecast',
    img: require('../images/storySparklines/projects.fivethirtyeight.com_election-2016_primary-forecast_plot.png'),
    publisher: 'FiveThirtyEight',
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'Crossing the Line: How Donald Trump Behaved With Women in Private',
    url: 'http://nytimes.com/2016/05/15/us/politics/donald-trump-women.html',
    img: require('../images/storySparklines/nytimes.com_2016_05_15_us_politics_donald-trump-women.html_plot.png'),
    publisher: 'The New York Times',
    authors: ['Michael Barbaro', 'Megan Twohey'],
    categories: ['politics'],
    medium: 'longform',
}, {
    title: 'US election poll tracker: Who is ahead - Clinton or Trump?',
    url: 'http://bbc.co.uk/news/election-us-2016-37450661',
    img: require('../images/storySparklines/bbc_news_election-us-2016-37450661_plot.png'),
    publisher: 'BBC',
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'Trump voters will not like what happens next',
    url: 'http://washingtonpost.com/opinions/trump-voters-will-not-like-what-happens-next/2016/11/09/e346ffc2-a67f-11e6-8fc0-7be8f848c492_story.html',
    img: require('../images/storySparklines/washingtonpost.com_opinions_trump-voters-will-not-like-what-happens-next_2016_11_09_e346ffc2-a67f-11e6-8fc0-7be8f848c492_story.html_plot.png'),
    publisher: 'Washington Post',
    authors: ['Garrison Keillor'],
    categories: ['politics', 'opinion'],
}, {
    title: 'Wife crashes her own funeral, horrifying her husband, who had paid to have her killed',
    url: 'http://washingtonpost.com/news/morning-mix/wp/2016/02/05/wife-crashes-her-own-funeral-horrifying-her-husband-who-had-paid-have-her-killed/',
    img: require('../images/storySparklines/washingtonpost.com_news_morning-mix_wp_2016_02_05_wife-crashes-her-own-funeral-horrifying-her-husband-who-had-paid-have-her-killed__plot.png'),
    publisher: 'Washington Post',
    authors: ['Sarah Kaplan'],
    categories: ['breaking'],
}, {
    title: 'Dallas sniper attack: 5 officers killed, suspect ID’d',
    url: 'http://cnn.com/2016/07/08/us/philando-castile-alton-sterling-protests/index.html',
    img: require('../images/storySparklines/cnn.com_2016_07_08_us_philando-castile-alton-sterling-protests_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Faith Karimi'],
    categories: ['breaking'],
}, {
    title: 'Latest Election Polls 2016',
    url: 'http://nytimes.com/interactive/2016/us/elections/polls.html',
    img: require('../images/storySparklines/nytimes.com_interactive_2016_us_elections_polls.html_plot.png'),
    publisher: 'The New York Times',
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'Stefanie Williams’ response to Yelp employee Talia Jane',
    url: 'http://www.businessinsider.com/stefanie-williams-response-to-yelp-employee-talia-jane-2016-2',
    img: require('../images/storySparklines/businessinsider__stefanie-williams-response-to-yelp-employee-talia-jane-2016-2_plot.png'),
    publisher: 'Business Insider',
    authors: ['Stefanie Williams'],
    categories: ['opinion', 'justice'],
}, {
    title: '‘You took away my worth’: A sexual assault victim’s powerful message to her Stanford attacker',
    url: 'http://washingtonpost.com/news/early-lead/wp/2016/06/04/you-took-away-my-worth-a-rape-victim-delivers-powerful-message-to-a-former-stanford-swimmer/',
    img: require('../images/storySparklines/washingtonpost.com_news_early-lead_wp_2016_06_04_you-took-away-my-worth-a-rape-victim-delivers-powerful-message-to-a-former-stanford-swimmer__plot.png'),
    publisher: 'Washington Post',
    authors: ['Lindsey Bever'],
    categories: ['justice'],
    medium: 'interactive',
}, {
    title: 'Trump Rally No Joking Matter',
    url: 'http://www.dailykos.com/story/2016/3/11/1499735/-Trump-Rally-No-Joking-Matter',
    img: require('../images/storySparklines/dailykos_story_2016_3_11_1499735_-Trump-Rally-No-Joking-Matter_plot.png'),
    publisher: 'Daily Kos',
    authors: ['keenekarl (username)'],
    categories: ['politics', 'opinion'],
}, {
    title: '2016 Caucus and Primary Results',
    url: 'http://cnn.com/specials/politics/2016-primaries-results',
    img: require('../images/storySparklines/cnn.com_specials_politics_2016-primaries-results_plot.png'),
    publisher: 'CNN',
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'Brexit: David Cameron to quit after UK votes to leave EU',
    url: 'http://www.bbc.com/news/uk-politics-36615028',
    img: require('../images/storySparklines/bbc__news_uk-politics-36615028_plot.png'),
    publisher: 'BBC',
    categories: ['politics'],
}, {
    title: 'Winning Powerball Tickets Sold in at Least 3 States for Nearly $1.6B Jackpot',
    url: 'http://abcnews.go.com/US/powerball-lottery-drawing-record-15b-jackpot-tonight/story?id=36275166',
    img: require('../images/storySparklines/abcnews.go.com_US_powerball-lottery-drawing-record-15b-jackpot-tonight__plot.png'),
    publisher: 'ABC News',
    authors: ['Meghan Keneally'],
    categories: ['breaking'],
}, {
    title: 'Falcon Heights shooting: Woman livestreams aftermath',
    url: 'http://cnn.com/2016/07/07/us/falcon-heights-shooting-minnesota/index.html',
    img: require('../images/storySparklines/cnn.com_2016_07_07_us_falcon-heights-shooting-minnesota_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Eliott C. McLaughlin'],
    categories: ['breaking', 'justice'],
}, {
    title: 'Primary / Caucus Results',
    url: 'http://www.usatoday.com/pages/interactives/elections-results-primaries-2016/',
    img: require('../images/storySparklines/usatoday.com_pages_interactives_elections-results-primaries-2016__plot.png'),
    publisher: 'USA Today',
    categories: ['politics'],
    medium: 'interactive'
}, {
    title: 'TrueHoop Presents: How Nike lost Stephen Curry to Under Armour',
    url: 'http://www.espn.com/nba/story/_/id/15047018/how-nike-lost-stephen-curry-armour',
    img: require('../images/storySparklines/espn_nba_story___id_15047018_how-nike-lost-stephen-curry-armour_plot.png'),
    publisher: 'ESPN',
    authors: ['Ethan Sherwood Strauss'],
    categories: ['sports'],
    medium: 'longform',
}, {
    title: 'Ten Things I Wish I Knew When I Started ‘Pokémon GO’',
    url: 'http://forbes.com/sites/insertcoin/2016/07/09/ten-things-i-wish-i-knew-when-i-started-pokemon-go/',
    img: require('../images/storySparklines/forbes.com_sites_insertcoin_2016_07_09_ten-things-i-wish-i-knew-when-i-started-pokemon-go__plot.png'),
    publisher: 'Forbes',
    authors: ['Paul Tassi'],
    categories: ['entertainment'],
}, {
    title: 'Brussels attacks: Zaventem and Maelbeek bombs kill many',
    url: 'http://www.bbc.com/news/world-europe-35869254',
    img: require('../images/storySparklines/bbc_news_world-europe-35869254_plot.png'),
    publisher: 'BBC',
    categories: ['breaking'],
}, {
    title: 'Nice attack: Dozens killed during Bastille Day celebrations',
    url: 'http://www.bbc.co.uk/news/live/world-europe-36799172',
    img: require('../images/storySparklines/bbc_news_live_world-europe-36799172_plot.png'),
    publisher: 'BBC',
    authors: ['Dominic Howell', 'Martha Buckley', 'Marysia Nowak', 'Ashley Gold'],
    categories: ['breaking'],
    medium: 'blog',
}, {
    title: 'Prince Autopsy Planned for Today',
    url: 'http://cnn.com/2016/04/21/entertainment/prince-estate-death/index.html',
    img: require('../images/storySparklines/cnn.com_2016_04_21_entertainment_prince-estate-death_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Catherine E. Shoichet', 'Ashley Fantz', 'Lisa Respers France'],
    categories: ['breaking'],
}, {
    title: 'Donald Trump Tax Records Show He Could Have Avoided Taxes for Nearly Two Decades, The Times Found',
    url: 'http://nytimes.com/2016/10/02/us/politics/donald-trump-taxes.html',
    img: require('../images/storySparklines/nytimes.com_2016_10_02_us_politics_donald-trump-taxes.html_plot.png'),
    publisher: 'The New York Times',
    authors: ['David Barstow', 'Susanne Craig', 'Russ Buettner', 'Megan Twohey'],
    categories: ['politics'],
}, {
    title: '21 Baby Names Voted ‘The Worst’ of 2016 ... So Far',
    url: 'http://thestir.cafemom.com/pregnancy/196854/14_baby_names_voted_the',
    img: require('../images/storySparklines/thestir.cafemom.com_pregnancy_196854_14_baby_names_voted_the_plot.eps.png'),
    publisher: 'The Stir',
    categories: ['culture'],
}, {
    title: 'My Four Months as a Private Prison Guard: A Mother Jones Investigation',
    url: 'http://www.motherjones.com/politics/2016/06/cca-private-prisons-corrections-corporation-inmates-investigation-bauer',
    img: require('../images/storySparklines/motherjones_politics_2016_06_cca-private-prisons-corrections-corporation-inmates-investigation-bauer_plot.png'),
    publisher: 'Mother Jones',
    authors: ['Shane Bauer'],
    categories: ['justice'],
    medium: 'longform',
}, {
    title: 'The real reason why women drink',
    url: 'http://qz.com/762868/giving-up-alcohol-opened-my-eyes-to-the-infuriating-truth-about-why-women-drink/',
    img: require('../images/storySparklines/qz.com_762868_giving-up-alcohol-opened-my-eyes-to-the-infuriating-truth-about-why-women-drink__plot.png'),
    publisher: 'Quartz',
    authors: ['Kristi Coulter'],
    categories: ['opinion', 'culture'],
    medium: 'longform',
}, {
    title: 'David Bowie dies of cancer aged 69',
    url: 'http://www.bbc.co.uk/news/entertainment-arts-35278872',
    img: require('../images/storySparklines/bbc_news_entertainment-arts-35278872_plot.png'),
    publisher: 'BBC',
    categories: ['breaking', 'entertainment'],
}, {
    title: 'Alton Sterling shooting: Second video of deadly encounter emerges',
    url: 'http://cnn.com/2016/07/06/us/baton-rouge-shooting-alton-sterling/index.html',
    img: require('../images/storySparklines/cnn.com_2016_07_06_us_baton-rouge-shooting-alton-sterling_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Catherine E. Shoichet', 'Joshua Berlinger', 'Steve Almasy'],
    categories: ['breaking', 'justice'],
}, {
    title: 'Police ID man who killed singer Christina Grimmie',
    url: 'http://cnn.com/2016/06/11/entertainment/orlando-christina-grimmie-shot/index.html',
    img: require('../images/storySparklines/cnn.com_2016_06_11_entertainment_orlando-christina-grimmie-shot_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Boris Sanchez', 'Ralph Ellis', 'Joe Sutton', 'Azadeh Ansari'],
    categories: ['breaking', 'entertainment'],
}, {
    title: 'After ‘The Biggest Loser,’ Their Bodies Fought to Regain Weight',
    url: 'http://nytimes.com/2016/05/02/health/biggest-loser-weight-loss.html',
    img: require('../images/storySparklines/nytimes.com_2016_05_02_health_biggest-loser-weight-loss.html_plot.png'),
    publisher: 'The New York Times',
    authors: ['Gina Kolata'],
    categories: ['entertainment'],
    medium: 'longform',
}, {
    title: 'Shandra Woworuntu: My life as a sex-trafficking victim',
    url: 'http://www.bbc.com/news/magazine-35846207',
    img: require('../images/storySparklines/bbc_news_magazine-35846207_plot.png'),
    publisher: 'BBC',
    authors: ['Shandra Woworuntu'],
    categories: ['justice'],
    medium: 'longform',
}, {
    title: 'The 282 People, Places and Things Donald Trump Has Insulted on Twitter: A Complete List',
    url: 'http://nytimes.com/interactive/2016/01/28/upshot/donald-trump-twitter-insults.html',
    img: require('../images/storySparklines/nytimes.com_interactive_2016_01_28_upshot_donald-trump-twitter-insults.html_plot.png'),
    publisher: 'The New York Times',
    authors: ['Jasmine C. Lee', 'Kevin Quealy'],
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'Donald Trump is a unique threat to American democracy',
    url: 'http://washingtonpost.com/opinions/donald-trump-is-a-unique-threat-to-american-democracy/2016/07/22/a6d823cc-4f4f-11e6-aa14-e0c1087f7583_story.html',
    img: require('../images/storySparklines/washingtonpost.com_opinions_donald-trump-is-a-unique-threat-to-american-democracy_2016_07_22_a6d823cc-4f4f-11e6-aa14-e0c1087f7583_story.html_plot.png'),
    publisher: 'Washington Post',
    authors: ['Editorial Board'],
    categories: ['politics', 'opinion'],
    medium: 'longform'
}, {
    title: 'The Mind of Donald Trump',
    url: 'https://www.theatlantic.com/magazine/archive/2016/06/the-mind-of-donald-trump/480771/',
    img: require('../images/storySparklines/theatlantic_magazine_archive_2016_06_the-mind-of-donald-trump_480771__plot.png'),
    publisher: 'The Atlantic',
    authors: ['Dan P. McAdams'],
    categories: ['politics'],
    medium: 'longform',
}, {
    title: 'The British are frantically Googling what the E.U. is, hours after voting to leave it',
    url: 'http://washingtonpost.com/news/the-switch/wp/2016/06/24/the-british-are-frantically-googling-what-the-eu-is-hours-after-voting-to-leave-it/',
    img: require('../images/storySparklines/washingtonpost.com_news_the-switch_wp_2016_06_24_the-british-are-frantically-googling-what-the-eu-is-hours-after-voting-to-leave-it__plot.png'),
    publisher: 'Washington Post',
    authors: ['Brian Fung'],
    categories: ['politics'],
}, {
    title: 'The Obama Doctrine',
    url: 'https://www.theatlantic.com/magazine/archive/2016/04/the-obama-doctrine/471525/',
    img: require('../images/storySparklines/theatlantic_magazine_archive_2016_04_the-obama-doctrine_471525__plot.png'),
    publisher: 'The Atlantic',
    authors: ['Jeffrey Goldberg'],
    categories: ['politics'],
    medium: 'longform',
}, {
    title: 'EgyptAir Flight MS804 latest updates',
    url: 'http://www.bbc.co.uk/news/live/world-africa-36328976',
    img: require('../images/storySparklines/bbc_news_live_world-africa-36328976_plot.png'),
    publisher: 'BBC',
    authors: ['Nalina Eggert', 'Joel Gunter', 'Alex Therrien'],
    categories: ['breaking'],
    medium: 'blog',
}, {
    title: 'Rio 2016 Olympics: Usain Bolt wins 100m gold',
    url: 'http://www.bbc.com/sport/live/olympics/36772906',
    img: require('../images/storySparklines/bbc_sport_live_olympics_36772906_plot.png'),
    publisher: 'BBC',
    authors: ['Tom Rostance'],
    categories: ['sports'],
    medium: 'blog',
}, {
    title: 'EU Referendum latest',
    url: 'http://www.bbc.com/news/live/uk-politics-36050790',
    img: require('../images/storySparklines/bbc_news_live_uk-politics-36050790_plot.png'),
    publisher: 'BBC',
    authors: ['Aiden James', 'Jackie Storer'],
    categories: ['politics'],
    medium: 'blog',
}, {
    title: 'Transfer deadline day',
    url: 'http://www.bbc.com/sport/live/football/35238092',
    img: require('../images/storySparklines/bbc_sport_live_football_35238092_plot.png'),
    publisher: 'BBC',
    authors: ['Tom Rostance'],
    categories: ['sports'],
    medium: 'blog'
}, {
    title: '52 Places to Go in 2016',
    url: 'http://nytimes.com/interactive/2016/01/07/travel/places-to-visit.html',
    img: require('../images/storySparklines/nytimes.com_interactive_2016_01_07_travel_places-to-visit.html_plot.png'),
    publisher: 'The New York Times',
    categories: ['culture'],
    medium: 'interactive',
}, {
    title: 'Fractured Lands: How the Arab World Came Apart',
    url: 'http://nytimes.com/interactive/2016/08/11/magazine/isis-middle-east-arab-spring-fractured-lands.html',
    img: require('../images/storySparklines/nytimes.com_interactive_2016_08_11_magazine_isis-middle-east-arab-spring-fractured-lands.html_plot.png'),
    publisher: 'The New York Times',
    authors: ['Scott Anderson'],
    categories: ['politics'],
    medium: 'interactive',
}, {
    title: 'As it happened: Final US election 2016 countdown',
    url: 'http://bbc.co.uk/news/live/election-us-2016-37825671',
    img: require('../images/storySparklines/bbc_news_live_election-us-2016-37825671_plot.png'),
    publisher: 'BBC',
    authors: ['Courtney Subramanian'],
    categories: ['politics'],
    medium: 'blog',
}, {
    title: 'Donald Trump’s decades-long history of misogynistic comments and crude sex talk',
    url: 'http://cnn.com/2016/10/08/politics/trump-on-howard-stern/index.html',
    img: require('../images/storySparklines/cnn.com_2016_10_08_politics_trump-on-howard-stern_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Andrew Kaczynski', 'Chris Massie', 'Nate McDermott'],
    categories: ['politics'],
}, {
    title: 'Footage shows suspects in Brussels attack',
    url: 'http://cnn.com/2016/03/22/europe/brussels-explosions/index.html',
    img: require('../images/storySparklines/cnn.com_2016_03_22_europe_brussels-explosions_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Catherine E. Shoichet', 'Frederik Pleitgen', 'Greg Botelho'],
    categories: ['breaking'],
}, {
    title: 'Astonishing new footage shows gorilla ‘PROTECTING’ boy and holding his hand before being shot dead',
    url: 'http://mirror.co.uk/news/world-news/astonishing-new-footage-shows-gorilla-8082168',
    img: require('../images/storySparklines/mirror.co.uk_news_world-news_astonishing-new-footage-shows-gorilla-8082168_plot.png'),
    publisher: 'Mirror',
    authors: ['John Shammas'],
    categories: ['breaking'],
}, {
    title: 'Your biggest Pokémon Go questions, answered',
    url: 'http://polygon.com/2016/7/6/12105992/pokemon-go-guide-faq-ios-android',
    img: require('../images/storySparklines/polygon.com_2016_7_6_12105992_pokemon-go-guide-faq-ios-android_plot.png'),
    publisher: 'Polygon',
    authors: ['Allegra Frank'],
    categories: ['entertainment'],
}, {
    title: 'Baton Rouge shooting: 3 officers dead; shooter was Missouri man, sources say',
    url: 'http://cnn.com/2016/07/17/us/baton-route-police-shooting/index.html',
    img: require('../images/storySparklines/cnn.com_2016_07_17_us_baton-route-police-shooting_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Steve Visser'],
    categories: ['breaking', 'justice'],
}, {
    title: 'No one to be fired after Melania Trump speech plagiarism episode',
    url: 'http://cnn.com/2016/07/19/politics/melania-trump-michelle-obama-speech/index.html',
    img: require('../images/storySparklines/cnn.com_2016_07_19_politics_melania-trump-michelle-obama-speech_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Gregory Krieg', 'Eric Bradner', 'Eugene Scott'],
    categories: ['politics'],
}, {
    title: 'Ghazala Khan: Trump criticized my silence. He knows nothing about true sacrifice.',
    url: 'http://washingtonpost.com/opinions/ghazala-khan-donald-trump-criticized-my-silence-he-knows-nothing-about-true-sacrifice/2016/07/31/c46e52ec-571c-11e6-831d-0324760ca856_story.html',
    img: require('../images/storySparklines/washingtonpost.com_opinions_ghazala-khan-donald-trump-criticized-my-silence-he-knows-nothing-about-true-sacrifice_2016_07_31_c46e52ec-571c-11e6-831d-0324760ca856_story.html_plot.png'),
    publisher: 'Washington Post',
    authors: ['Ghazala Khan'],
    categories: ['politics', 'opinion'],
}, {
    title: 'Police group: Minn. governor ‘exploited what was already a horrible and tragic situation’',
    url: 'http://washingtonpost.com/news/morning-mix/wp/2016/07/07/minn-cop-fatally-shoots-man-during-traffic-stop-aftermath-broadcast-on-facebook/',
    img: require('../images/storySparklines/washingtonpost.com_news_morning-mix_wp_2016_07_07_minn-cop-fatally-shoots-man-during-traffic-stop-aftermath-broadcast-on-facebook__plot.png'),
    publisher: 'Washington Post',
    authors: ['T. Rees Shapiro', 'Lindsey Bever', 'Wesley Lowery', 'Michael E. Miller'],
    categories: ['breaking', 'justice'],
}, {
    title: 'The most thorough, profound and moving defense of Hillary Clinton I have ever seen.',
    url: 'http://www.dailykos.com/story/2016/6/11/1537582/-The-most-thorough-profound-and-moving-defense-of-Hillary-Clinton-I-have-ever-seen',
    img: require('../images/storySparklines/dailykos_story_2016_6_11_1537582_-The-most-thorough-profound-and-moving-defense-of-Hillary-Clinton-I-have-ever-seen_plot.png'),
    publisher: 'Daily Kos',
    authors: ['NewDealer'],
    categories: ['politics', 'opinion'],
}, {
    title: 'US election 2016: What time are the election results?',
    url: 'http://bbc.co.uk/news/election-us-2016-37885746',
    img: require('../images/storySparklines/bbc_news_election-us-2016-37885746_plot.png'),
    publisher: 'BBC',
    categories: ['politics'],
}, {
    title: 'Dems open convention without Wasserman Schultz',
    url: 'http://cnn.com/2016/07/22/politics/dnc-wikileaks-emails/index.html',
    img: require('../images/storySparklines/cnn.com_2016_07_22_politics_dnc-wikileaks-emails_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Jeff Zeleny', 'MJ Lee', 'Eric Bradner'],
    categories: ['politics'],
}, {
    title: 'Nice attack: At least 84 killed by lorry at Bastille Day celebrations',
    url: 'http://www.bbc.com/news/world-europe-36800730',
    img: require('../images/storySparklines/bbc_news_world-europe-36800730_plot.png'),
    publisher: 'BBC',
    categories: ['breaking'],
}, {
    title: 'North Miami police shoot black man who said his hands were raised while he tried to help autistic patient',
    url: 'http://washingtonpost.com/news/morning-mix/wp/2016/07/21/fla-police-shoot-black-man-with-his-hands-up-as-he-tries-to-help-autistic-patient/',
    img: require('../images/storySparklines/washingtonpost.com_news_morning-mix_wp_2016_07_21_fla-police-shoot-black-man-with-his-hands-up-as-he-tries-to-help-autistic-patient__plot.png'),
    publisher: 'Washington Post',
    authors: ['Francisco Alvarado', 'Michael E. Miller', 'Mark Berman'],
    categories: ['breaking', 'justice'],
}, {
    title: 'A 7-year-old told her bus driver she couldn’t wake her parents. Police found them dead at home.',
    url: 'http://washingtonpost.com/news/to-your-health/wp/2016/10/05/a-7-year-old-told-her-bus-driver-she-couldnt-wake-her-parents-police-found-them-dead-at-home/',
    img: require('../images/storySparklines/washingtonpost.com_news_to-your-health_wp_2016_10_05_a-7-year-old-told-her-bus-driver-she-couldnt-wake-her-parents-police-found-them-dead-at-home__plot.png'),
    publisher: 'Washington Post',
    authors: ['Cleve R. Wootson Jr.'],
    categories: ['breaking'],
}, {
    title: 'As news of Trump’s taxes breaks, he goes off script at a rally in Pennsylvania',
    url: 'http://washingtonpost.com/news/post-politics/wp/2016/10/02/as-news-of-trumps-taxes-broke-he-goes-off-script-at-a-rally-in-pennsylvania/',
    img: require('../images/storySparklines/washingtonpost.com_news_post-politics_wp_2016_10_02_as-news-of-trumps-taxes-broke-he-goes-off-script-at-a-rally-in-pennsylvania__plot.png'),
    publisher: 'Washington Post',
    authors: ['Jenna Johnson'],
    categories: ['politics'],
}, {
    title: 'This House Costs Just $20,000—But It’s Nicer Than Yours',
    url: 'http://fastcoexist.com/3056129/this-house-costs-just-20000-but-its-nicer-than-yours',
    img: require('../images/storySparklines/fastcoexist.com_3056129_this-house-costs-just-20000-but-its-nicer-than-yours_plot.png'),
    publisher: 'Co.Exist',
    authors: ['Adele Peters'],
    categories: ['entertainment'],
}, {
    title: 'America Has Never Been So Ripe for Tyranny',
    url: 'http://nymag.com/daily/intelligencer/2016/04/america-tyranny-donald-trump.html',
    img: require('../images/storySparklines/nymag.com_daily_intelligencer_2016_04_america-tyranny-donald-trump.html_plot.png'),
    publisher: 'New York Magazine',
    authors: ['Andrew Sullivan'],
    categories: ['politics'],
    medium: 'longform',
}, {
    title: 'Trump issues defiant apology for lewd remarks -- then goes on the attack',
    url: 'http://cnn.com/2016/10/07/politics/donald-trump-women-vulgar/index.html',
    img: require('../images/storySparklines/cnn.com_2016_10_07_politics_donald-trump-women-vulgar_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Jeremy Diamond'],
    categories: ['politics'],
}, {
    title: 'Comey notified Congress of email probe despite DOJ concerns',
    url: 'http://cnn.com/2016/10/28/politics/fbi-reviewing-new-emails-in-clinton-probe-director-tells-senate-judiciary-committee/index.html',
    img: require('../images/storySparklines/cnn.com_2016_10_28_politics_fbi-reviewing-new-emails-in-clinton-probe-director-tells-senate-judiciary-committee_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Evan Perez', 'Pamela Brown'],
    categories: ['politics'],
}, {
    title: 'An Open Letter to Trump Voters from His Top Strategist-Turned-Defector',
    url: 'http://xojane.com/issues/stephanie-cegielski-donald-trump-campaign-defector',
    img: require('../images/storySparklines/xojane.com_issues_stephanie-cegielski-donald-trump-campaign-defector_plot.png'),
    publisher: 'xoJane',
    authors: ['Stephanie Cegielski'],
    categories: ['politics', 'opinion'],
}, {
    title: 'Elections 2016 Live Blog',
    url: 'http://www.foxnews.com/politics/elections/2016/events/elections-2016-live-blog',
    img: require('../images/storySparklines/foxnews.com_politics_elections_2016_events_elections-2016-live-blog_plot.png'),
    publisher: 'Fox News',
    categories: ['politics'],
    medium: 'blog',
}, {
    title: 'Here’s the SNL sketch that finally went too far for Donald Trump',
    url: 'http://washingtonpost.com/news/the-fix/wp/2016/10/16/heres-the-snl-that-finally-went-too-far-for-donald-trump/',
    img: require('../images/storySparklines/washingtonpost.com_news_the-fix_wp_2016_10_16_heres-the-snl-that-finally-went-too-far-for-donald-trump__plot.png'),
    publisher: 'Washington Post',
    authors: ['Aaron Blake'],
    categories: ['politics', 'entertainment'],
}, {
    title: 'Turkish President Erdogan appears in Istanbul to denounce army coup attempt',
    url: 'http://www.bbc.com/news/world-europe-36809083',
    img: require('../images/storySparklines/bbc_news_world-europe-36809083_plot.png'),
    publisher: 'BBC',
    categories: ['politics'],
}, {
    title: 'Alan Rickman, Harry Potter and Die Hard actor, dies aged 69',
    url: 'http://www.bbc.com/news/entertainment-arts-35313604',
    img: require('../images/storySparklines/bbc_news_entertainment-arts-35313604_plot.png'),
    publisher: 'BBC',
    categories: ['breaking', 'entertainment'],
}, {
    title: 'It’s ‘digital heroin’: How screens turn kids into psychotic junkies',
    url: 'http://nypost.com/2016/08/27/its-digital-heroin-how-screens-turn-kids-into-psychotic-junkies/',
    img: require('../images/storySparklines/nypost.com_2016_08_27_its-digital-heroin-how-screens-turn-kids-into-psychotic-junkies__plot.png'),
    publisher: 'New York Post',
    authors: ['Dr. Nicholas Kardaras'],
    categories: ['culture'],
}, {
    title: 'Why You Will Marry the Wrong Person',
    url: 'http://nytimes.com/2016/05/29/opinion/sunday/why-you-will-marry-the-wrong-person.html',
    img: require('../images/storySparklines/nytimes.com_2016_05_29_opinion_sunday_why-you-will-marry-the-wrong-person.html_plot.png'),
    publisher: 'The New York Times',
    authors: ['Alain de Botton'],
    categories: ['opinion', 'culture'],
    medium: 'longform',
}, {
    title: 'Why Voting for Donald Trump Is a Morally Good Choice',
    url: 'http://townhall.com/columnists/waynegrudem/2016/07/28/why-voting-for-donald-trump-is-a-morally-good-choice-n2199564',
    img: require('../images/storySparklines/townhall_columnists_waynegrudem_2016_07_28_why-voting-for-donald-trump-is-a-morally-good-choice-n2199564_plot.png'),
    publisher: 'Townhall',
    authors: ['Wayne Grudem'],
    categories: ['politics', 'opinion'],
}, {
    title: 'Angelina dumped Brad after private eye uncovered Marion Cotillard affair',
    url: 'http://pagesix.com/2016/09/20/angelina-dumped-brad-after-private-eye-uncovered-marion-cotillard-affair/',
    img: require('../images/storySparklines/pagesix.com_2016_09_20_angelina-dumped-brad-after-private-eye-uncovered-marion-cotillard-affair__plot.png'),
    publisher: 'Page Six',
    authors: ['Linda Massarella', 'Kate Sheehy', 'Emily Smith'],
    categories: ['entertainment'],
}, {
    title: 'Brexit: What happens now?',
    url: 'http://www.bbc.com/news/uk-politics-eu-referendum-36420148',
    img: require('../images/storySparklines/bbc_news_uk-politics-eu-referendum-36420148_plot.png'),
    publisher: 'BBC',
    categories: ['politics'],
}, {
    title: '4 Men with 4 Very Different Incomes Open Up About the Lives They Can Afford',
    url: 'http://esquire.com/lifestyle/money/a44086/four-men-four-numbers/',
    img: require('../images/storySparklines/esquire.com_lifestyle_money_a44086_four-men-four-numbers__plot.png'),
    publisher: 'Esquire',
    authors: ['David Walters'],
    categories: ['culture'],
}, {
    title: 'Five dead teens, a stolen cop car and the ‘most horrific’ crash in decades',
    url: 'http://washingtonpost.com/news/morning-mix/wp/2016/10/11/five-dead-teens-a-stolen-cop-car-and-the-most-horrific-crash-in-decades/',
    img: require('../images/storySparklines/washingtonpost.com_news_morning-mix_wp_2016_10_11_five-dead-teens-a-stolen-cop-car-and-the-most-horrific-crash-in-decades__plot.png'),
    publisher: 'Washington Post',
    authors: ['Katie Mettler'],
    categories: ['breaking'],
}, {
    title: 'Officer Tim McMillan Posts About Stopping a Black Man',
    url: 'http://attn.com/stories/11891/officer-tim-mcmillan-posts-about-pulling-over-black-man',
    img: require('../images/storySparklines/attn.com_stories_11891_officer-tim-mcmillan-posts-about-pulling-over-black-man_plot.png'),
    publisher: 'Attn',
    authors: ['Laura Donovan'],
    categories: ['justice'],
}, {
    title: 'Rio 2016: Usain Bolt wins ninth gold, GB hockey gold, Muhammad taekwondo bronze',
    url: 'http://www.bbc.com/sport/live/olympics/36773267',
    img: require('../images/storySparklines/bbc_sport_live_olympics_36773267_plot.png'),
    publisher: 'BBC',
    authors: ['Tom Rostance', 'Gary Rose'],
    categories: ['sports'],
    medium: 'blog',
}, {
    title: 'Latest on Hurricane Matthew',
    url: 'http://cnn.com/2016/10/06/us/hurricane-matthew-live-updates/index.html',
    img: require('../images/storySparklines/cnn.com_2016_10_06_us_hurricane-matthew-live-updates_index.html_plot.png'),
    publisher: 'CNN',
    authors: ['Amanda Wills', 'Holly Yan', 'Faith Karimi', 'Ralph Ellis'],
    categories: ['breaking'],
    medium: 'blog',
}, {
    title: 'Jo Cox MP dead after shooting attack',
    url: 'http://www.bbc.com/news/uk-england-36550304',
    img: require('../images/storySparklines/bbc_co_uk_news_uk-england-36550304_plot.png'),
    publisher: 'BBC',
    categories: ['breaking'],
}, {
    title: 'Melania Trump’s girl-on-girl photos from racy shoot revealed',
    url: 'http://nypost.com/2016/08/01/melania-trumps-girl-on-girl-photos-from-racy-shoot-revealed/',
    img: require('../images/storySparklines/nypost.com_2016_08_01_melania-trumps-girl-on-girl-photos-from-racy-shoot-revealed__plot.png'),
    publisher: 'New York Post',
    authors: ['Isabel Vincent'],
    categories: ['politics', 'entertainment'],
}, {
    title: 'How Reche Caldwell Googled his way from the Patriots to prison',
    url: 'http://www.espn.com/nfl/story/_/id/15472532/how-reche-caldwell-googled-way-patriots-prison',
    img: require('../images/storySparklines/espn_nfl_story___id_15472532_how-reche-caldwell-googled-way-patriots-prison_plot.png'),
    publisher: 'ESPN',
    authors: ['David Fleming'],
    categories: ['sports'],
}, {
    title: 'Anger over ‘Bregret’ as Leave voters say they thought UK would stay in EU',
    url: 'http://independent.co.uk/news/uk/politics/brexit-anger-bregret-leave-voters-protest-vote-thought-uk-stay-in-eu-remain-win-a7102516.html',
    img: require('../images/storySparklines/independent.co.uk_news_uk_politics_brexit-anger-bregret-leave-voters-protest-vote-thought-uk-stay-in-eu-remain-win-a7102516.html_plot.png'),
    publisher: 'Independent',
    categories: ['politics'],
    authors: ['Lizzie Dearden'],
}];

export default STORIES;



// WEBPACK FOOTER //
// ./src/utils/stories.js